<div id="main-visual" class="carousel slide" data-ride="carousel">

  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="/assets/images/main_visual01.jpg" alt="main visual">
    </div>
    <div class="carousel-item">
      <img src="/assets/images/main_visual02.jpg" alt="main visual">
    </div>
    <div class="carousel-item">
      <img src="/assets/images/main_visual03.jpg" alt="main visual">
    </div>
  </div>

  <!-- Left and right controls -->
  <a class="carousel-control-prev" href="#main-visual" data-slide="prev">
    <span class="carousel-control-prev-icon"></span>
  </a>
  <a class="carousel-control-next" href="#main-visual" data-slide="next">
    <span class="carousel-control-next-icon"></span>
  </a>

  <!-- Indicators -->
  <ul class="carousel-indicators carousel-indicators-change">
    <li data-target="#main-visual" data-slide-to="0" class="active"></li>
    <li data-target="#main-visual" data-slide-to="1"></li>
    <li data-target="main-visual" data-slide-to="2"></li>
  </ul>

  <div class="main-txt">
    <div><img src="/assets/images/kraia.png" alt="KRAIA" /></div>
    <div class="txt">Korea Refrigeration and<br />Air-conditioning Industry Association</div>
  </div>

</div>

<div class="cb"></div>

<div class="news main-wrap">
  <h2 class="section-title">News</h2>

  <!-- pc에서 보임 -->
  <div class="information-list card-list pc-1000">
    <swiper [config]="SwiperConfigInterface_news">
      <ul *ngFor="let key of checkLastPage(0)">
        <ng-container *ngFor='let item of boardData; let i = index'>
          <li *ngIf="checkLi(i, key)">
            <a routerLink="/en/board/view" [queryParams]="{board_id:'enews',board_seq:item.board_seq}">
              <p class="kind">News</p>
              <p class="title el">{{item.subject}}<p>
              <p class="date">{{item.write_date}}</p>
            </a>
          </li>
        </ng-container>
        <li *ngIf="key == getLastPage(0)" class="more">
          <a routerLink="/en/board/list" [queryParams]="{board_id:'enews'}">
            <p class="icon-more"></p>
            <p class="more-txt">More</p>
          </a>
        </li>
      </ul>
    </swiper>
    <div class="cb"></div>
  </div>
</div>

<div class="cb"></div>

<div class="member-search main-wrap">
  <h2 class="section-title">Member Search</h2>
  <div class="search-div">
    <div class="radio">
      <label>Company
        <input type="radio" name="radio" checked/>
        <span class="checkmark"></span>
      </label>
      <label>Product
        <input type="radio" name="radio" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div class="search-input">
      <input type="text" placeholder="search" />
      <button class="search-btn">search</button>
    </div>
  </div>
</div>

<div class="banner">
	<ul>
    <li><a href="http://www.abrava.com.br" target="_blank"><img src="/assets/images/e_banner01.png" alt="브라질냉동공조협회"></a></li>
    <li><a href="http://www.chinacraa.org/en/index.aspx" target="_blank"><img src="/assets/images/e_banner02.png" alt="중국냉동공조협회"></a></li>
    <li><a href="http://www.epeeglobal.org/" target="_blank"><img src="/assets/images/e_banner03.png" alt="유럽연합협회"></a></li>
    <li><a href="http://www.eurovent-association.eu" target="_blank"><img src="/assets/images/e_banner04.png" alt="유럽연합협회"></a></li>
    <li><a href="http://www.car.org.cn" target="_blank"><img src="/assets/images/e_banner05.png" alt="중국제냉학회"></a></li>
    <li><a href="https://www.facebook.com/Psvare-584249491614161/timeline/" target="_blank"><img src="/assets/images/e_banner06.png" alt="필리핀냉동공조협회"></a></li>
    <li><a href="http://www.icarhma.org" target="_blank"><img src="/assets/images/e_banner07.png" alt="세계냉동공조협회협의회"></a></li>
	</ul>
	<div class="cb"></div>
</div>
